import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeMetaParams, storeUtmParams } from "./lib/fbPixel";

// Initialize Meta parameters early (best practice per Meta Parameter Builder docs)
// This captures fbc, fbp, and client IP before any events are fired
initializeMetaParams();
storeUtmParams();

createRoot(document.getElementById("root")!).render(<App />);
